var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"l-button-main"},[_c('button',{staticClass:"l-btn-default",class:[_vm.activeType == _vm.type ? 'active': '', `l-btn-type-${_vm.type}`, _vm.status == 0 ? 'disabled' : '' ],on:{"click":function($event){return _vm.onSelect(_vm.type)}}},[_c('span',{staticClass:"l-btn-text"},[_vm._v(_vm._s(_vm.text))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }